import { Navigate } from 'react-router';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import SplashReport from '@/PowerBI/SplashReport';

/**
 * Component for the route of the selected site. Terminals flagged with usePowerBISplash land on a Power BI report,
 * everything else forwards on to the Board page.
 */
export default function SiteManagement() {
	const { usePowerBISplash } = useCurrentTerminal();

	if (usePowerBISplash) {
		return <SplashReport />;
	}

	return <Navigate to='Board' />;
}
